import React from 'react';
import { AgentTile } from '../AgentTile/AgentTile.jsx';
import { Stamp } from '../Stamp/Stamp.jsx';
import { BODY, MONO, ink } from '../../primitives.js';

const h = React.createElement;

/**
 * @param {object} p
 * @param {'me'|'them'} [p.from]
 * @param {string} [p.agent]
 * @param {React.ReactNode} [p.name]
 * @param {string} [p.time]
 * @param {React.ReactNode} [p.stamp]
 * @param {React.ReactNode} [p.children]
 */
export function ChatMessage({ from = 'them', agent, name, time, stamp, children }) {
  const me = from === 'me';
  return h('div', { style: { display: 'flex', flexDirection: me ? 'row-reverse' : 'row', alignItems: 'flex-end', gap: 8, fontFamily: BODY } },
    agent ? h(AgentTile, { name: agent, size: 26, border: 1.5 }) : null,
    h('div', { style: { maxWidth: '76%', display: 'flex', flexDirection: 'column', alignItems: me ? 'flex-end' : 'flex-start', gap: 4 } },
      name || time ? h('div', { style: { fontSize: 11, fontWeight: 700, color: 'var(--mut2)' } }, name, name && time ? ' · ' : '', time ? h('span', { style: { fontFamily: MONO, fontWeight: 400 } }, time) : null) : null,
      h('div', { style: { position: 'relative', padding: '8px 12px', border: ink(2), borderRadius: me ? '14px 14px 4px 14px' : '14px 14px 14px 4px', background: me ? 'var(--inkbg)' : agent ? 'var(--card)' : 'var(--paper)', color: me ? 'var(--oninkbg)' : 'var(--tx)', boxShadow: me ? '3px 3px 0 var(--gold)' : '3px 3px 0 var(--ink)', fontSize: 13, lineHeight: 1.45 } },
        stamp ? h(Stamp, { style: { position: 'absolute', top: -13, [me ? 'left' : 'right']: -8 } }, stamp) : null, children)));
}
